var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content model"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/colorfilter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colorfilter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 16.3642C14 18.1342 13.23 19.7342 12 20.8242C10.94 21.7842 9.54 22.3642 8 22.3642C4.69 22.3642 2 19.6742 2 16.3642C2 13.6042 3.88 11.2642 6.42 10.5742C7.11 12.3142 8.59 13.6542 10.42 14.1542C10.92 14.2942 11.45 14.3642 12 14.3642C12.55 14.3642 13.08 14.2942 13.58 14.1542C13.85 14.8342 14 15.5842 14 16.3642Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18 8.36426C18 9.14426 17.85 9.89426 17.58 10.5743C16.89 12.3143 15.41 13.6543 13.58 14.1543C13.08 14.2943 12.55 14.3643 12 14.3643C11.45 14.3643 10.92 14.2943 10.42 14.1543C8.59 13.6543 7.11 12.3143 6.42 10.5743C6.15 9.89426 6 9.14426 6 8.36426C6 5.05426 8.69 2.36426 12 2.36426C15.31 2.36426 18 5.05426 18 8.36426Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22 16.3642C22 19.6742 19.31 22.3642 16 22.3642C14.46 22.3642 13.06 21.7842 12 20.8242C13.23 19.7342 14 18.1342 14 16.3642C14 15.5842 13.85 14.8342 13.58 14.1542C15.41 13.6542 16.89 12.3142 17.58 10.5742C20.12 11.2642 22 13.6042 22 16.3642Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentModel);
export default __webpack_public_path__ + "static/media/Content_model.0996dc6db13667eda93f7438629333a6.svg";
export { ForwardRef as ReactComponent };